<template>
    <BRow>
        <BCol
            v-if="showDocumentPreview"
            cols="12"
            lg="5"
            class="document-compliance-layout-split__preview mb-1 mb-lg-0"
        >
            <slot name="documentPreview" />
        </BCol>
        <BCol
            cols="12"
            :lg="showDocumentPreview ? 7 : 12"
        >
            <slot name="heading" />
            <slot name="documentInformation" />
            <slot name="products" />
            <slot name="regulations" />
            <slot name="scipInformation" />
            <slot name="substances" />
            <slot name="completion" />
        </BCol>
    </BRow>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue'

export default {
    name: 'ProductsFirstSplitDocumentComplianceLayout',
    components: {
        BCol,
        BRow,
    },
    props: {
        showDocumentPreview: {
            type: Boolean,
            default: true,
        },
    },
}
</script>

<style scoped>
.document-compliance-layout-split__preview {
    position: sticky;
    top: 0;
    align-self: flex-start;
}

@media (max-width: 991.98px) {
    .document-compliance-layout-split__preview {
        position: static;
    }
}
</style>
